<template>
  <div style="overflow-y: auto; ">
    <div class="pl-1">
      <v-progress-linear
        indeterminate
        color="primary"
        class="pl-1"
        v-if="!fetched"
      ></v-progress-linear>
    </div>
    <span v-if="callsLimited.length === 0 && fetched">
      <v-alert outlined color="primary" class="ma-1">
        {{ $t("common.no_data_available") }}
      </v-alert>
    </span>
    <v-simple-table v-else height="211">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t("common.date") }}
            </th>
            <th class="text-left">{{ $t("common.phone") }}</th>
            <th class="text-left">{{ $t("common.customer") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="call in callsLimited" :key="call.id">
            <td>
              <span class="text-caption"
                >{{ call.created_at | moment("DD.MM.YYYY") }}
                {{ call.created_at | moment("HH:mm") }}</span
              >
            </td>
            <td>
              <span v-if="call.call_direction">
                <v-icon
                  v-if="call.call_direction === 1"
                  color="success"
                  class="ml-0 pl-0"
                >
                  mdi-call-received
                </v-icon>
                <v-icon
                  v-if="call.call_direction === 2"
                  color="danger"
                  class="ml-0 pl-0"
                >
                  mdi-call-made
                </v-icon>
                <v-icon v-if="call.call_direction === 0" class="ml-0 pl-0">
                  mdi-swap-vertical-variant
                </v-icon>
              </span>
              {{ call.phone }}
            </td>
            <td>
              <div v-if="call.customer">
                {{ call.customer.full_name }}
                {{
                  call.customer.is_company == 1
                      ? "[" + call.customer.legal_name + "]"
                      : ""
                }}
              </div>
            </td>
            <td>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  color="green"
                  class="mb-0 mr-1 px-0 white--text"
                  @click.stop="getCallRecord(call)"
                  :loading="
              !!records.find((rec) => rec.callId === call.id && rec.isFetching)
            "
                  :disabled="
              !call.recording_id ||
              !!records.find((rec) => rec.callId === call.id && rec.isFetching)
            "
              >
                <v-icon small>mdi-headphones</v-icon>
              </v-btn>
              <div
                  class="d-inline-block callRecPlayer"
                  v-if="
            !!records.find(
              (rec) => rec.callId === call.id && rec.isFetching === false
            )
          "
              >
                <vue-plyr
                    :key="call.recording_id"
                    :download="
              records.find((rec) => rec.callId === call.id && rec.file).file
            "
                    v-if="
              call.recording_id &&
              records.find(
                (rec) => rec.callId === call.id && rec.file && !rec.isFetching
              )
            "
                >
                  <audio controls crossorigin playsinline>
                    <source
                        :src="
                  records.find((rec) => rec.callId === call.id && rec.file).file
                "
                        type="audio/mp3"
                    />
                  </audio>
                </vue-plyr>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

  </div>
</template>

<script>
import CommonMixin from "@/mixins/common";
import { mapFields } from "vuex-map-fields";

export default {
  name: "MainWidgetCalls",
  mixins: [CommonMixin],
  components: {},
  props: {
    limit: {
      type: Number,
      default: 5,
    },
  },
  mounted() {
    this.$store.dispatch("calls/get");
  },
  computed: {
    ...mapFields("calls", [
      "calls",
      "fetched",
      "isCallRecordFetching",
      "records",
    ]),
    callsLimited() {
      return this.calls.splice(0, this.limit);
    },
  },
  methods: {
    getCallRecord(call) {
      this.$store.dispatch("calls/getCallRecord", call);
    },
  },
};
</script>

<style scoped></style>
